// extracted by mini-css-extract-plugin
export var filterIncDec = "_cg-0";
export var leftBorder = "_cg-1";
export var rightBorder = "_cg-2";
export var stringInput = "_cg-3";